import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Santiago Mendoza </span>
            from <span className="purple"> Buenos Aires, Argentina.</span>
            <br />As a Full Stack web developer, I have a solid knowledge base in several key technologies, including HTML, CSS, JavaScript, NodeJS, and React. My work experience has included challenging projects, working in teams and using agile methodologies and collaborative tools.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing sports
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">S.M.</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}
export default AboutCard;